import {
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { SharedModule } from '../../../shared/module/shared.module';
import { FrontendUserVerificationCodeModel } from '@coreModels';
import { AuthService } from '@coreApiServices';
import {
  LoaderService,
  SubscribersService,
  ToastService,
  TokenStorageService,
} from '@coreServices';
import { CommonConstants, STORAGE } from '@coreConstant';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-verify-account',
  standalone: true,
  imports: [ReactiveFormsModule, SharedModule],
  templateUrl: './verify-account.component.html',
  styleUrls: ['./verify-account.component.scss', '../auth.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VerifyAccountComponent {
  verificationForm!: any;
  submitted!: boolean;
  frontendUserVerificationCodeModel: any = FrontendUserVerificationCodeModel;
  tradeForm: any;
  @Output() type: EventEmitter<string> = new EventEmitter();
  destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private tokenStorageService: TokenStorageService,
    private toastService: ToastService,
    private subscribersService: SubscribersService,
    private modalService: NgbModal,
    public loaderService: LoaderService
  ) {}

  ngOnInit() {
    this.verificationForm = this.fb.group({
      otp: ['', Validators.required],
    });
    this.getTradeFormDetails();
  }

  getTradeFormDetails() {
    this.subscribersService.verificationTabForm
      .pipe(takeUntil(this.destroy$))
      .subscribe((options: any) => {
        this.tradeForm = options;
        delete this.tradeForm.confirm_email;
        delete this.tradeForm.confirm_password;
      });
  }

  get vf() {
    return this.verificationForm?.controls;
  }

  resendCode() {
    this.frontendUserVerificationCodeModel = {
      email: this.tradeForm.email,
    };

    this.loaderService.show();
    this.authService
      .reSendVerificationCode(this.frontendUserVerificationCodeModel)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.submitted = false;
          this.tokenStorageService.setItemStorage(
            STORAGE.EMAIL_KEY,
            this.frontendUserVerificationCodeModel.email
          );
          this.verificationForm.reset();
          this.toastService.showSuccess(
            CommonConstants.SUCCESS_VERIFICATION_CODE
          );
        },
        error: (error) => {
          if (error.status == 422) {
            this.toastService.showError(error);
          } else if (error.status == 401) {
            this.toastService.showError(error.error.data.message);
          }
        },
        complete: () => {
          this.loaderService.hide();
        },
      });
  }

  cancel() {
    // Open registration form
    this.type.emit('register');
  }

  onSubmit() {
    this.submitted = true;
    this.verificationForm.markAllAsTouched();
    if (this.verificationForm.invalid) return;

    this.frontendUserVerificationCodeModel = {
      email: this.tokenStorageService.getItemStorage(STORAGE.EMAIL_KEY),
      verification_code: this.verificationForm.value.otp,
    };

    this.authService
      .verifiyCode(this.frontendUserVerificationCodeModel)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (
            res.is_two_factor_verified == CommonConstants.IS_TWO_FACTOR_VERIFIED
          ) {
            this.submitted = false;
            this.tradeFormSubmit();
            this.verificationForm.reset();
          }
        },
        error: (error) => {
          if (error.status == 422) {
            let self = this;
            if (error.error.data.length > 0) {
              Object.keys(error.error.data).forEach(function (key, data) {
                self.verificationForm.controls[
                  error.error.data[key].field
                ].setErrors({ apiError: error.error.data[key].message });
              });
            }
          } else if (
            error.status == 401 ||
            error.status == 404 ||
            error.status == 400
          ) {
            this.toastService.showError(error.error.data.message);
          }
        },
      });
  }

  tradeFormSubmit() {
    this.submitted = true;
    this.loaderService.show();
    this.authService
      .signUp(this.tradeForm)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.submitted = false;
          this.toastService.showSuccess(
            CommonConstants.SUCCESS_USER_REGISTERED
          );
          this.modalService.dismissAll();
        },
        error: (error) => {
          this.toastService.showError(error.error.data.message);
        },
        complete: () => {
          this.loaderService.hide();
        },
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
